import ConfigureRadix from "components/ConfigureRadix";

import styles from "./radix.module.scss";

interface Props {
  onClose: () => void;
}

// Skrót do ustawień integracji RADIX z poziomu modułu (koło zębate na pasku listy).
// Właściwe miejsce konfiguracji to Ustawienia → Integracje → RADIX (ten sam formularz
// ConfigureRadix); tutaj tylko po to, żeby nie wychodzić z modułu przy pierwszym imporcie.
const RadixSettingsModal = ({ onClose }: Props) => (
  <div className={styles.overlay} onMouseDown={onClose}>
    <div className={`${styles.modal} ${styles.modalWide}`} onMouseDown={(e) => e.stopPropagation()}>
      <div className={styles.modalTitle}>Ustawienia RADIX</div>
      <div className={styles.modalBody}>
        <div className={styles.hint}>
          Te same ustawienia znajdziesz w Ustawienia → Integracje → RADIX.
        </div>
        <ConfigureRadix embedded isUpdate toggle={onClose} onSuccess={onClose} />
      </div>
    </div>
  </div>
);

export default RadixSettingsModal;
